import { render, staticRenderFns } from "./UserAdresses.vue?vue&type=template&id=02a6cca5&scoped=true&"
import script from "./UserAdresses.vue?vue&type=script&lang=js&"
export * from "./UserAdresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a6cca5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02a6cca5')) {
      api.createRecord('02a6cca5', component.options)
    } else {
      api.reload('02a6cca5', component.options)
    }
    module.hot.accept("./UserAdresses.vue?vue&type=template&id=02a6cca5&scoped=true&", function () {
      api.rerender('02a6cca5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/UserAdresses.vue"
export default component.exports